import { enterSpace } from '../../app/actions/spaces/EnterSpaceAction';
import { updateBreadcrumbs } from '../../app/actions/UpdateBreadcrumbsAction';
import { appStore } from '../../app/AppStore';
import { addUrlWatchersToScopeForExplorer } from '../../app/spaces/Explorer/ExplorerUrlBindings';
import { FavoritesSpaceOwnProps } from '../../app/spaces/FavoritesSpace/FavoritesSpace';
import { setURLParametersOrDefaultsForEnteringSpaceAndFetchContent } from '../../app/spaces/SpaceConfig/SiteSpaceConfigHelper';
import { SpaceItemForNonEntitySpace } from '../../app/state/SpaceInfo';
import { Messages } from '../../codegen/Localize';
import { getQueryStringServiceFromAngular } from '../../common/react/QueryString';
import { AngularContextFactory } from '../factories/AngularContextFactory';
import { Module } from '../Module';
import { BrowserTitleService } from '../services/BrowserTitleService';
import { Telemetry } from '../services/TelemetryService';

export interface IFavoritesSpaceScope extends ng.IScope {
  favoritesSpaceProps: FavoritesSpaceOwnProps;
}

export class FavoritesSpaceCtrl {

  private currentPath: string;

  public static $inject = [
    '$location',
    '$scope',
    'BrowserTitleService',
    'TelemetryService',
    'AngularContextFactory',
  ];

  constructor(
    $location: ng.ILocationService,
    $scope: IFavoritesSpaceScope,
    browserTitleService: BrowserTitleService,
    telemetryService: Telemetry,
    angularContextFactory: AngularContextFactory,
  ) {
    browserTitleService.setTitleWithPlaceEntityName({ placeEntityName: Messages.favoritesBrowserTitle() });

    const angularContext = angularContextFactory.create($scope);
    $scope.favoritesSpaceProps = {
      telemetry: telemetryService,
      angularContext
    };

    // Must be done before any of the setting of sorts and defaults below
    appStore.dispatch(enterSpace({
      item: SpaceItemForNonEntitySpace,
      spaceType: 'favorites',
      subspaceName: undefined
    }));

    appStore.dispatch(updateBreadcrumbs([]));

    const queryString = getQueryStringServiceFromAngular($location);
    this.currentPath = $location.path();
    const getPath = () => {
      return this.currentPath;
    };

    // need to reset all filters and sorts when entering the favorites space
    setURLParametersOrDefaultsForEnteringSpaceAndFetchContent(appStore, $location);
    addUrlWatchersToScopeForExplorer({ $scope, $location, queryString, store: appStore, getPreviousPath: getPath });
  }
}

Module.instance().controller('FavoritesSpaceCtrl', FavoritesSpaceCtrl);
